module.exports = __webpack_public_path__ + "static/media/ledger.54a5393d.svg";